export const symptoms = [
    {
      title: 'General Sypmtoms',
      values: [
        { title: 'Fever', value: false },
        { title: 'Chills', value: false },
        { title: 'Weakness', value: false },
        { title: 'Fatigue', value: false },
        { title: 'Insomnia', value: false },
        { title: 'Weight loss', value: false },
      ],
    },
    {
      title: 'Neurology/Head',
      values: [
        { title: 'Headache', value: false },
        { title: 'Dizziness', value: false },
        { title: 'Fainting', value: false },
        { title: 'Seizure', value: false },
        { title: 'Stroke-like symptoms*', value: false },
      ],
    },
    {
      title: 'Eyes',
      values: [
        { title: 'Pink eye', value: false },
        { title: 'Stye', value: false },
        { title: 'Vision loss', value: false },
      ],
    },
    {
      title: 'Nose',
      values: [
        { title: 'Sinus infection', value: false },
        { title: 'Nasal discharge', value: false },
        { title: 'Congestion', value: false },
        { title: 'Seasonal allergies', value: false },
      ],
    },
    {
      title: 'Ears',
      values: [
        { title: 'Earache', value: false },
        { title: 'Ear drainage', value: false },
        { title: 'Ringing in the ears', value: false },
        { title: 'Hearing loss', value: false },
      ],
    },
    {
      title: 'Throat',
      values: [
        { title: 'Sore throat', value: false },
        { title: 'Painful swallowing', value: false },
      ],
    },
    {
      title: 'Neck',
      values: [{ title: 'Swollen glands', value: false }],
    },
    {
      title: 'Cardiovascular',
      values: [
        { title: 'Chest pain/pressure', value: false },
        { title: 'Palpitations', value: false },
      ],
    },
    {
      title: 'Skin/Dermatology',
      values: [
        { title: 'Rash', value: false },
        { title: 'Skin spots', value: false },
        { title: 'Insect bites', value: false },
        { title: 'Sores', value: false },
        { title: 'Itching', value: false },
        { title: 'Sunburn', value: false },
      ],
    },
    {
      title: 'Travel-Related',
      values: [
        { title: 'Traveler’s diarrhea', value: false },
        { title: 'Malaria (possible)', value: false },
        { title: 'Dengue (possible)', value: false },
        { title: 'Zika (possible)', value: false },
        { title: 'Motion sickness', value: false },
        { title: 'Altitude illness', value: false },
      ],
    },
    {
      title: 'Minor Injuries / Musculoskeletal',
      values: [
        { title: 'Back pain', value: false },
        { title: 'Back injury', value: false },
        { title: 'Ankle sprain', value: false },
        { title: 'Joint pain/swelling', value: false },
        { title: 'Bruises/contusions', value: false },
        { title: 'Decreased range of motion', value: false },
        { title: 'Puncture wound', value: false },
      ],
    },
    {
      title: 'Respiratory',
      values: [
        { title: 'Shortness of breath*', value: false },
        { title: 'Cough', value: false },
        { title: 'Wheezing', value: false },
        { title: 'Cold symptoms', value: false },
        { title: 'Flu symptoms', value: false },
        { title: 'Barky cough', value: false },
      ],
    },
    {
      title: 'Gastrointestinal (GI)',
      values: [
        { title: 'Nausea', value: false },
        { title: 'Vomiting', value: false },
        { title: 'Diarrhea', value: false },
        { title: 'Abdominal pain', value: false },
        { title: 'Constipation', value: false },
        { title: 'Acid reflux', value: false },
        { title: 'Difficulty swallowing', value: false },
      ],
    },
    {
      title: 'Genitourinary (GU)',
      values: [
        { title: 'Flank pain', value: false },
        { title: 'Burning to urinate', value: false },
        { title: 'Painful urination', value: false },
        { title: 'Bloody urine', value: false },
        { title: 'Vaginal bleeding', value: false },
        { title: 'Vaginal discharge', value: false },
        { title: 'Penile discharge', value: false },
        { title: 'Testicular pain', value: false },
      ],
    },
    {
      title: 'Allergies',
      values: [
        { title: 'Rash', value: false },
        { title: 'Itching', value: false },
        { title: 'Tongue/throat swelling*', value: false },
      ],
    },
    {
      title: 'Psychiatric',
      values: [
        { title: 'Depression', value: false },
        { title: 'Suicidal thoughts*', value: false },
        { title: 'Homicidal thoughts*', value: false },
        { title: 'Disorganized thinking', value: false },
      ],
    },
    {
      title: 'Major/Serious Injuries*',
      values: [
        { title: 'Head injury*', value: false },
        { title: 'Neck injury*', value: false },
        { title: 'Chest trauma*', value: false },
        { title: 'Abdominal trauma*', value: false },
        { title: 'Trauma to the spine*', value: false },
        { title: 'Fractures*', value: false },
        { title: 'Dislocations*', value: false },
      ],
    },
    {
      title: 'Serious or Potentially Serious Conditions*',
      values: [
        { title: 'Stroke-like symptoms*', value: false },
        { title: 'Sudden loss of vision*', value: false },
        { title: 'Chest pain/tightness*', value: false },
        { title: 'Palpitations*', value: false },
        { title: 'Irregular heartbeat*', value: false },
        { title: 'Skipped heartbeat*', value: false },
        { title: 'Decreased exercise tolerance*', value: false },
        { title: 'Leg swelling*', value: false },
        { title: 'Significant weight gain*', value: false },
        { title: 'Cuts or lacerations*', value: false },
      ],
    },
  ];
  
  export const majorOrSeriousInjuries = [
    'Head injury*',
    'Neck injury*',
    'Chest trauma*',
    'Abdominal trauma*',
    'Trauma to the spine*',
    'Fractures*',
    'Dislocations*',
    'Stroke-like symptoms*',
    'Sudden loss of vision*',
    'Chest pain/tightness*',
    'Palpitations*',
    'Irregular heartbeat*',
    'Skipped heartbeat*',
    'Decreased exercise tolerance*',
    'Leg swelling*',
    'Significant weight gain*',
    'Cuts or lacerations*',
  ];
  